import { useProps } from "@/lib/page-rendering"
import { SearchShortlistsShortlistOption } from "@/types/serializers"

export type NewProps = {
  shortlists: Array<SearchShortlistsShortlistOption>
  educator_id: string
}

export const useNewProps = () => useProps<NewProps>()
